// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__o24Eh","projectsContent":"Projects_projectsContent__hHTXP","projectsTitle":"Projects_projectsTitle__vEpHp"};